<template>
  <div class="ptMain" id="ptMain">
    <div>
      <vue-headful
        :title="appTitle"
        :description="appDesc"
      />
    </div>
    <portal-target name="myPortal"></portal-target>
    <span class="appHeader" @click="ahClicked">
      <h1 id="appHead" role="heading"
           @click="headClick"
           :style="{ fontSize: fontSize + 'px' }"
      >{{ appName }}<br />{{ cuName }}</h1>
      <diag-list v-if="showDiagList"
                 class="diagW"
                 @exit="closeDiag">
      </diag-list>
      <zBanner v-if="banners.count > 0 && showBannerFlag"
               class="banZ">
      </zBanner>
    </span>
    <span>
      <!-- Back Button on sub page ends up at top of this div (has position: relative) -->
      <div class="subPage">
        <!-- Start of Sign-In Page -->
        <div v-if="pgIndex === 0">
        <!-- <sign-in @result="loginResult" @diag="writeStatus"></sign-in> -->
        <sign-in></sign-in>
        </div>
        <!-- End of Sign-In Page -->
        <!-- Start of Account Summary Page -->
        <div v-if="pgIndex === 1">
          <div class="nameHeader"
               :style="{ fontSize: fonts.font30 + 'px' }">
                {{ member.acct }} {{ member.name }}
          </div>
          <shSum></shSum>
          <lnSum v-if="loanCount > 0"></lnSum>
        </div>
        <!-- End of Account Summary Page -->
        <!-- ----------------------------------- -->
        <!-- Start of Bill-Pay Page -->
        <div v-if="pgIndex === 2">
          <billPay></billPay>
        </div>
        <!-- End of Bill-Pay Page -->
        <!-- ----------------------------------- -->
        <!-- Start of transferFunds Page -->
        <div v-if="pgIndex === 3">
            <transfer></transfer>
        </div>
        <!-- End of transferFunds Page -->
        <!-- ----------------------------------- -->
        <!-- Start of history Page -->
        <div v-if="pgIndex === 4">
          <history></history>
        </div>
        <!-- End of history Page -->
        <!-- ----------------------------------- -->
        <!-- Start of historySearch Page -->
        <div v-if="pgIndex === 5">
          <search></search>
        </div>
        <!-- End of historySearch Page -->
        <!-- ----------------------------------- -->
        <!-- Start of authorize Page -->
        <div v-if="pgIndex === 6">
          <zAuth></zAuth>
      </div>
        <!-- End of authorize Page -->
        <!-- ----------------------------------- -->
        <!-- Start of unAuthorize Page -->
        <div v-if="pgIndex === 7">
          <unAuth></unAuth>
        </div>
        <!-- End of unAuthorize Page -->
        <!-- ----------------------------------- -->
        <!-- Start of confirm Page -->
        <div v-if="pgIndex === 8">
          <zConfirm></zConfirm>
        </div>
        <!-- End of confirm Page -->
        <!-- ----------------------------------- -->
        <!-- Start of Posting Result Page -->
        <div v-if="pgIndex === 9">
          <postResult></postResult>
        </div>
        <!-- End of Posting Result Page -->
        <!-- ----------------------------------- -->
        <!-- Start of Select-Statement Page -->
        <div v-if="pgIndex === 10">
          <selectStmt></selectStmt>
        </div>
        <!-- End of Select-statement Page -->
        <!-- ----------------------------------- -->
        <!-- Start of Show-Statement Page -->
        <div v-if="pgIndex === 11">
          <showStmt></showStmt>
        </div>
        <!-- End of Show-statement Page -->
        <!-- ----------------------------------- -->
        <!-- Start of SelectCU Page -->
        <div v-if="pgIndex === 12">
          <selectCU></selectCU>
        </div>
        <!-- End of SelectCU Page -->
        <!-- ----------------------------------- -->
        <!-- Start of passChange Page -->
        <div v-if="pgIndex === 13">
          <passChange></passChange>
        </div>
        <!-- End of passChange Page -->
        <!-- ----------------------------------- -->
        <!-- Start of unlockAccount Page -->
        <div v-if="pgIndex === 14">
          <unlockAcct></unlockAcct>
        </div>
        <!-- End of unlockAccount Page -->
        <!-- ----------------------------------- -->
        <!-- Start of enroll Page -->
        <div v-if="pgIndex === 15">
          <enroll></enroll>
        </div>
        <!-- End of enroll Page -->
        <!-- ----------------------------------- -->
        <!-- Start of showPDF Page -->
        <div v-if="pgIndex === 16">
          <showPDF></showPDF>
        </div>
        <!-- End of showPDF Page -->
        <!-- ----------------------------------- -->
        <!-- Start of xferOther Page -->
        <div v-if="pgIndex === 17">
          <xferOther></xferOther>
        </div>
        <!-- End of xferOther Page -->
        <!-- ----------------------------------- -->
        <!-- Start of setupPins Page -->
        <div v-if="pgIndex === 18">
          <setupPins callOption="auth"></setupPins>
        </div>
        <!-- End of setupPins Page -->
        <!-- ----------------------------------- -->
        <!-- Start of setupPins Page -->
        <div v-if="pgIndex === 19">
          <setupPins callOption="edit"></setupPins>
        </div>
        <!-- End of setupPins Page -->
        <!-- ----------------------------------- -->
      </div>
    </span>
    <b-alert
      :show="da.diagShown"
      dismissible
      @dismissed="hideDiag"
      :variant="diagLevel">
      {{ da.diagMesg }}
    </b-alert>
    <b-alert class="alertRed"
      dismissible
      :show="alert.show"
      :style="{ fontSize: fonts.font14 + 'px' }"
      @dismissed="hideAlert">
      {{ alert.message }}
    </b-alert>
    <b-alert class="confirmGreen"
      dismissible
      :show="confirm.show"
      :style="{ fontSize: fonts.font12 + 'px' }"
      @dismissed="hideConfirm">
      {{ confirm.message }}
    </b-alert>
    <portal to="myPortal">
      <div id="hamX"
           v-if="showMenuButton"
           @click="menuButton">
        <div id="hamMenu"
             class="container">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
        <div id="hamWordMenu"
             :style="{ fontSize: fonts.font14 + 'px' }">Menu</div>
      </div>
      <zMenu id="menuOver" :head="appVer" v-if="showHam"></zMenu>
      <button id="time"
              v-if="showMenuButton"
              @click="timeReset"
              :style="{ fontSize: fontSize + 'px', top: btnTop + 'px' }">
        {{ tOutStr }}
      </button>
    </portal>
    <modal name="soConfirm"
           :width="300"
           :height="150"
           :clickToClose="false">
      <div class="soConfirm">
        <div id="soTitle">Automatic Sign-Out in: {{ tOutStr }}</div>
        <div>Are you sure you want to sign-out?</div>
        <b-button-group class="btnGroup">
          <button id="soYes"
                  @click="signOutYes">Sign-Out</button>
          <button id="soCancel"
                  @click="signOutCancel">Cancel</button>
        </b-button-group>
      </div>
    </modal>
    <!-- [139] -->
    <modal name="myPmModal"
           :width="340"
           :height="200"
           :clickToClose="false">
      <div class="pushedMessage">
        <div id="pmTitle">{{ pmTitle }}</div>
        <p v-html="pmMessage"></p>
        <b-button-group class="btnGroup">
          <button id="pmOk"
                  @click="hidePmMessage">OK</button>
        </b-button-group>
      </div>
    </modal>
    <!-- [166] Warning Modal -->
    <modal name="myWmModal"
           :width="400"
           :height="250"
           :clickToClose="false">
      <div class="pushedMessage">
        <div id="wmTitle">{{ wmTitle }}</div>
        <p id="wmMessage" v-html="wmMessage"></p>
        <b-button-group class="btnGroup">
          <button id="wmOk"
                  @click="hideWmMessage">OK</button>
        </b-button-group>
      </div>
    </modal>
    <!-- [176] Export Download Confirm box -->
    <modal name="myExportModal"
      :width="400"
      :height="170"
      :clickToClose="false">
      <div class="pushedMessage">
        <div id="exTitle">{{ exTitle }}</div>
        <p v-html="exMessage"></p>
        <b-button-group id="exBtnGroup">
          <button id="exOk"
                  @click="exportDownload">Download</button>
          <button id="exCancel"
                  @click="exportCancel">Cancel</button>
        </b-button-group>
      </div>
    </modal>
  </div>
</template>

<script>
// eslint-disable-next-line
import axios from 'axios';
import signIn from './p00-signIn';
import billPay from './billPay';
import transfer from './p03-xferFunds';
import history from './p04-history';
import search from './p05-search';
import diagList from './diagList';
import zMenu from './z-menu';
import zBanner from './z-banner';
import shSum from './z-shareSummary';
import lnSum from './z-loanSummary';
import zAuth from './z-auth';
import unAuth from './z-unAuth';
import zConfirm from './z-confirm';
import postResult from './postResult';
import selectStmt from './selectStmt';
import showStmt from './showStmt';
import showPDF from './showPDF';
import selectCU from './selectCU';
import passChange from './passChange';
import unlockAcct from './unlockAcct';
import enroll from './enroll';
import xferOther from './xferOther';
import setupPins from './setupPins';
import utl from '../myUtils';

// src="https://cdn.jsdelivr.net/npm/promise-polyfill@8/dist/polyfill.min.js";
export default {
  components: {
    shSum,
    lnSum,
    zMenu,
    zBanner,
    signIn,
    billPay,
    transfer,
    history,
    search,
    diagList,
    zAuth,
    unAuth,
    zConfirm,
    postResult,
    selectStmt,
    showStmt,
    showPDF,
    selectCU,
    passChange,
    unlockAcct,
    enroll,
    xferOther,
    setupPins,
    /* WARNING - When adding new pages, add to STORE: pageDesc: */
  },
  name: 'ptMain',
  data() {
    return {
      saveTime: 0,
      // iCount: 0,
      ws: null,
      bbCount: 0,
      diagMsg: '',
      showDiag: false,
      // showDiagWindow: false,
      diagLevel: '',
      savePg: 0,
      szVal: 1,
      wCtrl: false,
      htype: 'L',
      fontSize: 30,
      btnTop: 14,
      nameHeadSize: 24,
      verHead: 'Recover Your Password',
      inWidth: 500,
      initIDB: null,
      newIdxDB: false,
      dbInitComplete: false,
      diagSeq: 0,
      diagKey: [1, 3, 4, 2, 4],
      testSeq: 0,
      testKey: [1, 1, 4, 4, 2],
    };
  },
  watch: {
    cun() {
      this.writeDiag(`CU Number Changed - CUN=${this.cun}`);
    },
    soWarn() {
      if (this.soWarn === true) {
        this.$modal.show('soConfirm');
      } else {
        this.$modal.hide('soConfirm');
      }
    },
    exShow() { // [161]
      if (this.exShow === true) {
        this.$modal.show('myExportModal');
      } else {
        this.$modal.hide('myExportModal');
      }
    },
    pmShow() { // [139]
      if (this.pmShow === true) {
        this.$modal.show('myPmModal');
      } else {
        this.$modal.hide('myPmModal');
      }
    },
    wmShow() { // [139]
      if (this.wmShow === true) {
        this.$modal.show('myWmModal');
      } else {
        this.$modal.hide('myWmModal');
      }
    },
    myTenthSecond() {
      this.intervalTenthSecond();
    },
    mySecond() {
      this.intervalSecond();
    },
    showMenuButton() {
      if (this.showMenuButton) {
        //
      } else {
        //
      }
    },
    pgIndex() {
      // utl.diag(`Watcher: pgIndex() - pgState=${this.pgIndex}`);
    },
  },
  computed: {
    exportInfo() {
      return this.$store.getters.getExportInfo;
    },
    exShow() {
      return this.$store.getters.getExShow;
    },
    exTitle() {
      return this.$store.getters.getExTitle;
    },
    exMessage() {
      return this.$store.getters.getExMessage;
    },
    pmShow() {
      return this.$store.getters.getPmShow;
    },
    pmTitle() {
      return this.$store.getters.getPmTitle;
    },
    pmMessage() {
      return this.$store.getters.getPmMessage;
    },
    wmShow() {
      return this.$store.getters.getWmShow;
    },
    wmTitle() {
      return this.$store.getters.getWmTitle;
    },
    wmMessage() {
      return this.$store.getters.getWmMessage;
    },
    appTitle() {
      return this.$store.getters.getAppTitle;
    },
    appDesc() {
      return this.$store.getters.getAppDescription;
    },
    persist() {
      return this.$store.getters.getPersist;
    },
    initLevel() {
      return this.$store.getters.getInitLevel;
    },
    /* idb() {
      return this.$store.getters.getIndexedDB;
    }, */
    post() {
      return this.$store.getters.getPostData;
    },
    loanCount() {
      return this.$store.getters.getLoanCount;
    },
    cliWidth() {
      // return this.$store.getters.getCliWidth;
      return window.innerWidth;
    },
    navVer() {
      return this.$store.getters.getNavVer;
    },
    showDiagList() {
      return this.$store.getters.getShowDiagList;
    },
    soWarn() {
      return this.$store.getters.getSignOutWarn;
    },
    pgDesc() {
      return this.$store.getters.getPageDesc;
    },
    bfKey() {
      return this.$store.getters.getBfKey;
    },
    seshID() {
      return this.$store.getters.getSeshID;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    showHam() {
      return this.$store.getters.getShowHam;
    },
    pgIndex() {
      return this.$store.getters.getPageIndex;
    },
    showMenuButton() {
      return this.$store.getters.getShowMenuButton;
    },
    pause() {
      return this.$store.getters.getPauseStatus;
    },
    member() {
      return this.$store.getters.getMember;
    },
    winSize() {
      return this.$store.getters.getWinSize;
    },
    myTenthSecond() {
      return this.$store.getters.getMyTenth;
    },
    mySecond() {
      return this.$store.getters.getMySecond;
    },
    showBannerFlag() {
      return this.$store.getters.getShowBanner;
    },
    signedIn() {
      return this.$store.getters.getSiStatus;
    },
    da() {
      return this.$store.getters.getDiagAlert;
    },
    appName() {
      return this.$store.getters.getAppName;
    },
    appVer() {
      return this.$store.getters.getAppVer;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    cuName() {
      return this.$store.getters.getCuName;
    },
    banners() {
      return this.$store.getters.getBanners;
    },
    seconds() {
      return (this.date - this.now) % 60;
    },
    minutes() {
      return Math.trunc((this.date - this.now) / 60) % 60;
    },
    tOut() {
      return this.$store.getters.getTimeOut;
    },
    tOutStr() {
      const tm = this.$store.getters.getTimeOut;
      const minutes = Math.floor(tm / 60);
      const seconds = tm - (minutes * 60);
      return `${minutes}:${this.pad(seconds, 2)}`;
    },
    query() {
      return this.$store.getters.getQuery;
    },
    fullPath() {
      return this.$store.getters.getFullPath;
    },
    seImg() {
      return this.$store.getters.getSeImage;
    },
    confirm() {
      return this.$store.getters.getConfirm;
    },
    alert() {
      return this.$store.getters.getAlert;
    },
    binVer() {
      return this.$store.getters.getBinVer;
    },
  },
  methods: {
    /* popWarning(title, message) {
      const wm = {}; // Warning Message
      wm.show = true;
      wm.title = title;
      wm.message = message;
      this.$store.commit('setModalWarn', wm);
    }, */
    getStorage(key) {
      return this.persist[key];
    },
    ahClicked(event) {
      const target = event.target || event.srcElement;
      let hit = 0;
      const vCenter = target.clientHeight / 2;
      const hCenter = target.clientWidth / 2;
      if (event.offsetX < hCenter - 50) hit = 1;
      if (event.offsetX > hCenter + 50) hit = 2;
      if ((hit > 0) && (event.offsetY > vCenter)) {
        hit += 2;
      }
      if (hit === this.diagKey[this.diagSeq]) {
        this.diagSeq += 1;
      } else {
        this.diagSeq = 0;
      }
      if (this.diagSeq === 5) {
        this.diagSeq = 0;
        this.$store.commit('setShowDiagList', true);
      }

      if (hit === this.testKey[this.testSeq]) {
        this.testSeq += 1;
      } else {
        this.testSeq = 0;
      }
      if (this.testSeq === 5) {
        this.testSeq = 0;
        // this.$store.commit('setTestModalPM', true);
        const t1 = 'Authentication Error';
        const l1 = 'The Account Number or PIN you specified<br />';
        const l2 = 'for the destination account is invalid.<br />';
        const l3 = 'Verify the destination number is correct<br />';
        const l4 = 'and also review the following two help sections:<br />';
        const l5 = '<span style="color:red;">"OTHER" Destination Account</span><br />';
        const l6 = '<span style="color:red;">PIN button (setup Destination Pin)</span>';
        utl.popWarning(this.$store.commit, t1, `${l1}${l2}${l3}${l4}${l5}${l6}`);
      }
    },
    signOutYes() {
      this.$store.commit('signOut', true);
    },
    signOutCancel() {
      this.timeReset(); // Reset to 5:00 because we prior forced to 0:10
      this.$store.commit('forcePageIndex', 0); // so prior page is 0 and we go forward to 1
      this.$store.commit('setPageIndex', 1); // go back to page 1
      this.$store.commit('setSignOutWarn', false); // Remove the confirmation popup
    },
    exportCancel() {
      this.$store.commit('clrExMessage'); // Remove the Modal popup - Cancel
    },
    exportDownload() {
      this.$store.commit('clrExMessage'); // Remove the Modal popup - Download
      // utl.diag(`ExportURL: ${this.exportInfo.sourceURL}`);
      // utl.diag(`DefaultFile: ${this.exportInfo.destinFile}`);
      axios.get(`${this.exportInfo.sourceURL}`, { responseType: 'blob' })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${this.exportInfo.destinFile}`);
          document.body.appendChild(link);
          link.click();
        });
    },
    hidePmMessage() {
      this.$store.commit('clrPmMessage'); // Remove the Pushed Message popup
    },
    hideWmMessage() {
      this.$store.commit('clrWmMessage'); // [166] Remove the Warning Message popup
    },
    hideConfirm() {
      this.$store.commit('setConfirmShow', false);
    },
    hideAlert() {
      this.$store.commit('setAlertShow', false);
    },
    pauser() {
      this.$store.commit('setPauseStatus', !this.pause);
    },
    hideDiag() {
      this.$store.commit('hideDiag');
    },
    pad(num, size) {
      const s = `000000000${num}`;
      return s.substr(s.length - size);
    },
    headClick() {
      /* [182] Diable clicking on App Header
      if (this.pgIndex === 12) {
        window.history.back();
      } else if (this.pgIndex === 0) { // Only go to page 12 from page 0 (if CU Name clicked)
        this.$store.commit('loadCuList');
        this.$store.commit('setCuListSubPage', 0); // Main sub page
        this.$store.commit('setPageIndex', 12); // go back to page 12
      }
      */
    },
    back() {
      this.$store.commit('setPageIndex', this.pgIndex - 1);
    },
    next() {
      this.$store.commit('setPageIndex', this.pgIndex + 1);
    },
    szM() {
      this.szVal = parseFloat((this.szVal - 0.01).toFixed(2));
      const c = document.getElementById('ptMain');
      const ctx = c.getContext('2d');
      ctx.scale(2, 2);
    },
    szP() {
      this.szVal = parseFloat((this.szVal + 0.01).toFixed(2));
    },
    setCtrl() {
      this.wCtrl = !this.wCtrl;
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      // data.ver = this.binVer;
      this.$store.commit('sendObjToServer', data);
    },
    // showBanner(status) {
    // this.$store.commit('setShowBanner', status);
    // },
    openDiag() {
      // this.showDiagWindow = !this.showDiagWindow;
      this.$store.commit('setShowDiagList', !this.showDiagList);
    },
    closeDiag() {
      // this.showDiagWindow = false;
      this.$store.commit('setShowDiagList', false);
    },
    writeStatus(message) {
      this.$store.commit('showDiag', message);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', `main: ${message}`);
    },
    resize() {
      // eslint-disable-next-line
      this.writeStatus('Width: ' + this.winSize.W + ' X Height: ' + this.winSize.H);
      this.scaleText();
    },
    scaleText() {
      let w = this.winSize.W;
      // let w = document.documentElement.clientWidth;
      if (w > 1000) w = 1000;
      if (w < 430) w = 430;
      /* this.btnTop = w / 100; */
      this.btnTop = 2;
      this.fontSize = w / 30;
      this.nameHeadSize = w / 24;
    },
    menuButton() {
      this.$store.commit('toggleHam');
      // const x = document.getElementById('hamMenu');
      // x.classList.toggle('change');
      this.timeReset();
    },
    timeReset() {
      // this.iCount = 0;
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = this.member.acct;
      cuInfo.page = this.pgIndex;
      cuInfo.navVer = this.navVer;
      if (this.pgIndex === 1) {
        this.wsSend('c4Refresh', cuInfo);
      } else {
        this.wsSend('c4Reset', cuInfo);
      }
    },
    /*
    loginResult(form) {
      if (form.type === 'login') {
        this.signIn(form);
      }
      if (form.type === 'enroll') {
        this.enroll(form);
      }
      if (form.type === 'forgot') {
        this.forgot(form);
      }
    },
    forgot() {
      this.verHead = 'Forgot Password';
      this.$store.commit('setPageIndex', 2);
    },
    enroll(form) {
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = form.user;
      this.wsSend('c4FullPing', cuInfo);
    },
    signIn(form) {
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = form.user;
      cuInfo.siUser = ''; // Not a valid option (yet)
      cuInfo.siPass = form.pass;
      cuInfo.siSaveUser = form.saveAcct;
      cuInfo.siSavePass = form.savePass;
      cuInfo.navVer = this.navVer;
      this.wsSend('c4SignIn', cuInfo);
    },
    */
    intervalTenthSecond() {
      this.scaleText();
      //------------------------------------------------------------------------------------
      // This section times mobile APP out after it's been IDLE (non-forefront) for 10+ seconds
      const d = new Date();
      const myTime = d.getTime(); // number of milliseconds since 01/01/1070
      if (this.saveTime !== 0) {
        if ((myTime - this.saveTime) > 10000) { /* greater than 10 seconds w/o counting */
          this.$store.commit('signOut', true); // False = prompt for confirm - true = force signout
        }
      }
      this.saveTime = myTime; // REAL time to know if Mobile App paused
      // This section times mobile APP out after it's been IDLE (non-forefront) for 10+ seconds
      //------------------------------------------------------------------------------------
      if (this.initLevel === 1) {
        this.$store.commit('setInitLevel', 2);
        this.finalInit();
      }
    },
    intervalSecond() {
      // Nothing to do here
    },

    finalInit() {
      // this.writeDiag('final-Init()');
      /*
      const navigatorInfo = window.navigator;
      const screenInfo = window.screen;
      let uid = navigatorInfo.mimeTypes.length;
      uid += navigatorInfo.userAgent.replace(/\D+/g, '');
      uid += navigatorInfo.plugins.length;
      uid += screenInfo.height || '';
      uid += screenInfo.width || '';
      uid += screenInfo.pixelDepth || '';
      this.writeDiag(`UID: ${uid}`);
      */
      this.writeDiag(`cun: ${this.getStorage('cun')}`);
      this.writeDiag(`appName: ${this.getStorage('appName')}`);
      this.$store.commit('putFullPath', this.$route.fullPath);
      this.$store.commit('putQuery', this.$route.query);
      // utl.diag(this.$route);
      const thisUrl = window.location.href;
      // utl.diag(thisUrl);
      // let jsServ = 'ptserv'; // ptserv.pt4web.com
      // eslint-disable-next-line
      let jsServ = 'ptapp'; // ptapp.pt4web.com
      // if (thisUrl.indexOf('192.168.') > 0) jsServ = 'betaserv'; // betaserv.pt4web.com

      if (thisUrl.indexOf('192.168.') > 0) jsServ = 'ptapp2'; // ptapp2.pt4web.com
      if (thisUrl.indexOf('ptapp2.') > 0) jsServ = 'ptapp2'; // ptapp2.pt4web.com

      this.$store.commit('setSocketSub', jsServ);
      const fullPath = this.$route.fullPath;
      this.writeDiag(`fullPath: ${fullPath}`);
      this.writeDiag(`websocket: ${jsServ}.pt4web.com`);

      let cun = 0;
      let cux = 0;
      // const tempAppName = localStorage.getItem('AppName');
      const tempAppName = this.getStorage('AppName');
      if (typeof tempAppName !== 'undefined') {
        this.$store.commit('setAppName', tempAppName);
      }

      // Try to read CU Number from URL
      if (fullPath.length > 5) {
        // https://ptapp.pt4web.com/xxxxx <-- Try Here
        cux = parseInt(fullPath.substr(1, 5), 10);
        if ((cux > 12999) && (cux < 65536)) {
          cun = cux;
          this.writeDiag(`Path CUN=${cun}`);
          this.$store.dispatch('setCuNumber', cun);
        }
      }

      // If not found on URL line, try reading from Persistent Storage
      if (cun === 0) {
        cux = parseInt(this.persist.cun, 10);
        // this.writeDiag(`From Persist: CUN=${cux}`);
        if ((cux > 12999) && (cux < 65535)) {
          cun = cux;
          this.$store.dispatch('setCuNumber', cun);
          // this.writeDiag(`localStorage CUN=${cun}`);
        }
      }

      // If not found on URL line and not found in Persistent Storage,
      // this is the first time to use the app - Prompt for CU number.
      // Do NOT default to 22000
      if (cun === 0) {
        /* [182] Don't prompt for CU number
        this.writeDiag('Prompt for CU Number');
        this.$store.commit('setCuListSubPage', 0); // Main sub page
        this.$store.commit('setPageIndex', 12); // Request CU Number
        cun = '10101'; // Temp
        this.$store.dispatch('setCuNumber', cun);
        this.cun = cun;
        const cuInfo = {};
        cuInfo.cun = this.cun; // Open the connection to the server
        this.wsSend('c4GetMyCuName', cuInfo); // Request CU Name - Will Auto-connect
        */
      } else {
        const tempCuName = utl.getCuName(this.$store.commit, cun);
        if (typeof tempCuName !== 'undefined') {
          // utl.diag(`Found CU: ${tempCuName}`);
          this.$store.commit('setCuName', tempCuName);
        } else {
          this.$store.commit('setCuName', 'App Retired'); // [182] Display THIS CU Name
          // this.$store.commit('setCuName', 'Contacting Credit Union Server...');
          const cuInfo = {};
          cuInfo.cun = this.cun;
          this.wsSend('c4GetMyCuName', cuInfo); // Request CU Name - Will Auto-connect
        }
      }
    },
    handleKeyStroke(e) {
      utl.diag(`appMain-keyPressed: ${e.keyCode}`);
      if (e.keyCode === 13) { // Enter Pressed
        const e1 = document.activeElement;
        utl.diag(`Focused Element: ${e1}`);
        utl.diag(e1);
        // if (e1.eid === 'siUser')
        this.$refs.siPass.$el.focus();
      }
    },
    focusChanged(event) {
      const e1 = event.target;
      utl.diag(`ElementGotFocus: ${e1.ref} ${e1.id} ${e1.class}`);
    },
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.getWindowWidth);
    // window.removeEventListener('resize', this.getWindowHeight);
    // clearInterval(this.intervalSecond);
  },
  created() {
    this.writeDiag('Perfect-Teller App - Program Started');
    // this.writeDiag('dispatch store:initApp');
    this.$store.dispatch('initApp');
    this.onResize = () => {
      this.$store.commit('setWindowSize', {
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', this.onResize);

    // fire once immediately
    this.onResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  .ptMain {
    position: relative;
    min-width: 330px;
    max-width: 900px;
    left: 0;
    right: 0;
    width: 100%;
    horiz-align: center;
    font-weight: bold;
    border: solid 1px black;
    display: inline-block;
    background-color: lightcyan;
  }
  .appHeader {
    position: relative;
    display: inline-block;
    background-color: lightgray;
    top: 0;
    left: 0;
    width: 100%;
    padding-bottom: 2px;
    /* height: 80px; */
    border: solid 2px black;
  }
  #appHead{
    position: relative;
    display: inline-flex;
    /* border: solid 1px red; */
    width: auto;
    horiz-align: center;
    margin: 0;
    padding: 0 20px;
    font-weight: bold;
    color: black;
  }
  #hamX {
    position: absolute;
    display: block;
    height: 28px;
    width: 90px;
    /* border: solid 1px black; */
    color: white;
    top: 5px;
    left: 2px;
    z-index: 100;
    cursor: pointer;
  }
  #hamMenu {
    position: absolute;
    display: block;
    background: transparent;
    color: white;
    top: 3px;
    left: -5px;
    z-index: 100;
    cursor: pointer;
    /* border: solid 1px black; */
  }
  #hamWordMenu {
    position: absolute;
    display: block;
    top: 5px;
    left: 48px;
    background: transparent;
    color: blue;
  }
  #menuOver {
    position: absolute;
    display: block;
    top: 79px;
    z-index: 110;
  }
  #time {
    position: absolute;
    background: green;
    color: white;
    font-size: 24px;
    font-weight: bold;
    right: 10px;
    z-index: 100;
  }
  .diagW {
    z-index: 104;
    position: relative;
    horiz-align: left;
    width: 100%;
    border: solid 1px black;
  }
  .alertRed {
    background: #e4606d;
    color: black;
    font-weight: bold;
  }
  .confirmGreen {
    background: #d4edda;
    color: black;
    font-weight: bold;
  }
  .banZ {
    position: relative;
    display: inline-flex;
    horiz-align: center;
    border: solid 1px blue;
    /* display: inline-block; */
  }
  * {
    margin: 0;
  }
  .nameHeader {
    position: relative;
    margin: 0 0 1px;
    padding: 0 0 0 60px;
    color: black;
    font-size: 24px;
    font-weight: bold;
    border: solid 2px black;
  }
  .subPage {
    position: relative;
    margin: 0;
    padding: 0;
  }
  .container {
    display: inline-block;
    cursor: pointer;
  }
  #soTitle {
    background-color: red;
    color: black;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 20px;
  }
  .soConfirm {
    position: relative;
    height: 100%;
    background-color: white;
    border: solid 8px black;
    text-align: center;
    z-index: 999;
  }
  #pmTitle {
    background-color: blue;
    color: white;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 20px;
  }
  .pushedMessage {
    position: relative;
    height: 100%;
    background-color: white;
    border: solid 8px black;
    text-align: center;
    z-index: 999;
  }
  #pmOk {
    width: 120px;
    margin-left: 4px;
    margin-right: 4px;
    background-color: lightgreen;
    font-weight: bold;
  }
  #wmTitle {
    background-color: red;
    color: black;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 10px;
    border: solid 1px black;
  }
  #wmMessage {
    height: 150px;
    /* border: solid 1px red; */
    margin-bottom: 5px;
  }
  #wmOk {
    /* position: absolute;
    top: 100px;
    left: -60px; */
    width: 120px;
    margin-left: 4px;
    margin-right: 4px;
    background-color: lightgreen;
    font-weight: bold;
  }
  .btnGroup {
    margin: 0;
    padding: 0;
  }
  #soYes {
    margin-top: 20px;
    width: 120px;
    margin-left: 4px;
    margin-right: 4px;
    background-color: lightgreen;
    font-weight: bold;
  }
  #soCancel {
    margin-top: 20px;
    width: 120px;
    margin-left: 4px;
    margin-right: 4px;
    background-color: lightpink;
    font-weight: bold;
  }
  #exTitle {
    background-color: blue;
    color: white;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 20px;
  }
  #exBtnGroup {
    margin: 15px 0 0;
    padding: 0;
    /*
    position: absolute;
    height: 36px;
    width: 256px;
    top: 140px;
    left: 40px;
    margin: auto;
    border: solid 1px red; */
  }
  #exOk {
    width: 120px;
    margin-left: 4px;
    margin-right: 4px;
    background-color: lightgreen;
    font-weight: bold;
  }
  #exCancel {
    width: 120px;
    margin-left: 4px;
    margin-right: 4px;
    background-color: red;
    font-weight: bold;
  }
</style>
<!-- This is a GLOBAL-SCOPE CSS so we can access Hamburg menu CSS from the STORE -->
<style>
  .bar1, .bar3 {
    width: 30px;
    height: 3px;
    /* background-color: #333; */
    background-color: #ffeeba;
    margin: 4px 0;
    transition: 0.25s;
  }
  .bar2 {
    width: 30px;
    height: 2px;
    background-color: #333;
    margin: 4px 0;
    transition: 0.25s;
  }

  .change .bar1 {
    -webkit-transform: rotate(-45deg) translate(0px, 0px);
    transform: rotate(-45deg) translate(-3px, 6px);
    background-color: red;
  }

  .change .bar2 {opacity: 0;}

  .change .bar3 {
    -webkit-transform: rotate(45deg) translate(0px, 0px);
    transform: rotate(45deg) translate(-3px, -6px);
    background-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/appMain.vue